<template>
    <div class="card shadow">
        <div class="card-header text-center">Prochaines échéances</div>
        <div class="card-body p-0">
            <div class="deadlines-container">
                <div v-if="deadlines.length > 0">
                    <b-card
                        v-for="deadline in deadlines"
                        :key="deadline.id"
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="deadline-created">
                            {{ deadline.deadline_date_for_humans }} par
                            {{ deadline.assigned_to.name }}
                        </p>
                        <hr class="mb-1 mt-1" />
                        <p class="deadline-description">{{ deadline.title }}</p>
                    </b-card>
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="deadline-description">
                            Aucune échéance à venir prochainement
                        </p>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientNextDeadlines',

    props: {
        client: 0,
    },

    data() {
        return {
            deadlines: [],
        }
    },

    async created() {
        await this.getDeadlines()
    },

    methods: {
        async getDeadlines() {
            {
                try {
                    const response = await axios.get(
                        `/clientDeadlines/home/${this.client}`
                    )
                    this.deadlines = response.data.data
                } catch (error) {
                    console.log(error)
                }
            }
        },
    },
}
</script>

<style scoped>
.deadlines-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 650px;
}

.deadline-client {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
}

.deadline-description {
    margin-bottom: 0;
}

.deadline-created {
    font-size: 11px;
    margin-bottom: 0;
    font-style: italic;
}
</style>
